(function () {
  "use strict";

  var DEFAULT_ROOT_MARGIN = "200px 0px";

  function fetchSectionHtml(url) {
    return fetch(url, { priority: "low", credentials: "same-origin" }).then(function (response) {
      if (!response.ok) throw new Error("Section fetch failed");
      return response.text();
    });
  }

  function observeAndLoad(el, loadFn) {
    if (!("IntersectionObserver" in window)) {
      loadFn();
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(el);
          loadFn();
        });
      },
      { rootMargin: DEFAULT_ROOT_MARGIN }
    );
    observer.observe(el);
  }

  /** Deferred apps / review sections (placeholder on first paint). */
  var DeferredSection = class extends HTMLElement {
    connectedCallback() {
      if (this._loading) return;
      this._loading = true;
      var sectionId = this.getAttribute("data-section-id");
      if (!sectionId) return;

      var url =
        window.location.pathname +
        window.location.search +
        (window.location.search ? "&" : "?") +
        "section_id=" +
        encodeURIComponent(sectionId);

      var self = this;
      observeAndLoad(this, function () {
        fetchSectionHtml(url)
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var next = doc.querySelector("#shopify-section-" + sectionId);
            var host = self.closest(".shopify-section");
            if (next && host) {
              host.replaceWith(document.importNode(next, true));
            } else if (next) {
              self.replaceWith(document.importNode(next, true));
            }
          })
          .catch(function () {
            self.removeAttribute("aria-busy");
          });
      });
    }
  };

  /** Metafield upsell: shell stays, product tiles load when near viewport. */
  var DeferredUpsell = class extends HTMLElement {
    connectedCallback() {
      if (this._loading) return;
      this._loading = true;
      var slot = this.querySelector("[data-deferred-upsell-slot]");
      if (!slot) return;

      var handle = this.getAttribute("data-product-handle");
      if (!handle) return;

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      var url = root + "products/" + encodeURIComponent(handle) + "?section_id=deferred-metafield-upsell";

      var self = this;
      observeAndLoad(this, function () {
        fetchSectionHtml(url)
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var content =
              doc.querySelector("[data-deferred-upsell-content]") ||
              doc.querySelector(".horizontal-product-list");
            if (content) {
              slot.replaceWith(document.importNode(content, true));
            } else {
              self.remove();
            }
          })
          .catch(function () {
            self.remove();
          });
      });
    }
  };

  if (!window.customElements.get("deferred-section")) {
    window.customElements.define("deferred-section", DeferredSection);
  }
  if (!window.customElements.get("deferred-upsell")) {
    window.customElements.define("deferred-upsell", DeferredUpsell);
  }
})();
